export const INTERNAL_SUBSCRIPTION = "InternalSubscriptionPlan";
export const STRIPE_SUBSCRIPTION = "StripeSubscriptionPlan";
